import React from 'react'
import SignUpPage from '../../screens/SignUpPage/SignUpPage.component'

const SignUpRoute: React.FC = () => {
  return (
    <SignUpPage />
  )
}

export default SignUpRoute
